import { render, staticRenderFns } from "./ShippingGroupSelector.vue?vue&type=template&id=6b7cc446&scoped=true&"
import script from "./ShippingGroupSelector.vue?vue&type=script&lang=js&"
export * from "./ShippingGroupSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7cc446",
  null
  
)

export default component.exports